import { useContext, useEffect, useState } from 'react';
import icon from '../../_assets/img/new.png';
import { useHistory } from 'react-router-dom';
import MainContext from '../../_helpers/Contexts/mainContext';
import Aggrement from '../Steps/Aggrement';
const New = () => {
    const history = useHistory();
    const { ifManagerGlobal, setManagerGlobal } = useContext(MainContext);

    const createDeclaration = () => {
        history.push({
            pathname: '/step1',
            state: { new: true, fromLocalStorage: false }
        });

        localStorage.setItem('type', 'new');
        localStorage.removeItem('step1');
        localStorage.removeItem('step2');
        localStorage.removeItem('step3');
        localStorage.removeItem('step4');
        localStorage.removeItem('step44');
        localStorage.removeItem('step45');
        localStorage.removeItem('largeFamily');
        localStorage.removeItem('step4valid');
        localStorage.removeItem('step44valid');
        localStorage.removeItem('coOwner');
        localStorage.removeItem('step5');
        localStorage.removeItem('payment');
        localStorage.removeItem('printType');
        localStorage.removeItem('stepManager');
        localStorage.removeItem('agreement');
        localStorage.removeItem('consent');
        localStorage.removeItem('2023');
        localStorage.removeItem('D1');
        localStorage.removeItem('step31');
        localStorage.removeItem('TypeOfActivitySection');
        if (setManagerGlobal) setManagerGlobal(false);
    };

    return (
        <>
            <div className="col-12">
                <a href="" onClick={(e) => createDeclaration()}>
                    <div className="card option" onClick={(e) => createDeclaration()}>
                        <div className="row">
                            <div className="col-2 d-flex justify-content-around imgCard imgCardL">
                                <img src={icon} alt="Zostanie stworzna nowa deklaracja" />
                            </div>
                            <div className="col-10 imgCardR">
                                <div className="secendaryHeader">
                                    <div className="TitleCategory">Nowa deklaracja</div>
                                </div>
                                <p className="card-text">Kreator przeprowadzi Cię przez proces tworzenia nowej deklaracji.</p>
                            </div>
                        </div>
                    </div>
                </a>
            </div>
            {/* {!agreement ? <Aggrement agreement={agreement ?? true} setAgreement={setAgreement} /> : null} */}
        </>
    );
};

export { New };
